import { instanceEmployee } from '../../../../services/instances';

const getWorkPosition = async (params: Record<string, any> = {}): Promise<any> => {
    const response = await instanceEmployee.get<any>('/work_position', { params });
    return response.data.data;
};

export { getWorkPosition };
